import '../../../../../motion-utils/dist/es/errors.mjs';
import { motionValue } from '../../../../../motion-dom/dist/es/value/index.mjs';
import '../../../../../motion-dom/dist/es/frameloop/index-legacy.mjs';
import { isMotionValue } from '../../value/utils/is-motion-value.mjs';
import { animateMotionValue } from '../interfaces/motion-value.mjs';

function animateSingleValue(value, keyframes, options) {
    const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
    motionValue$1.start(animateMotionValue("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

export { animateSingleValue };
